import { Action } from '@zaibot/fsa';

export default Action<{
    tenantId: string;
    tenantName: string;
    docId: string;
    docName: string;
    pageId: number;
    pageName: string;
    pageNumber: number;
    pageCount: number;
    pageUrl: string;
    breadcrumb: string;
    mailToName: string;
    mailToAddress: string;
}>('METADATA_CHANGE');



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/meta/actions/CHANGE.tsx